import { Storage } from "@capacitor/storage";
import { ConfAccount } from "../../context/account/paramsAccount";

export const loadModeHorsligne = async (type: string, conf: ConfAccount) => {
  try {
    const { value } = await Storage.get({ key: `${type}_${conf.user.user_code}` });
    if (value) {
      return JSON.parse(value);
    }
    return null;
  } catch (error) {
    console.error('Error loading data:', error);
    return null;
  }
};
